/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Card_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search cards..." |
*
* @param {Card_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const card_search_placeholder = /** @type {((inputs?: Card_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Card_Search_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des cartes...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar cartas...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar cartas...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca carte...")
	return /** @type {LocalizedString} */ ("Search cards...")
});